<template>
  <div class="page-container" style="min-height: auto;">
    <Toast ref="toast" />

    <div class="page-title-container">
      <h1 class="title-text">Admin Job Offer Detail</h1>
    </div>

    <div class="center-items">
      <button class="primary-button" style="margin-right: 1rem;" @click="$router.push({ path: '/admin' })">⬅️ Back to Admin</button>

      <select class="input-container" v-model="option" @change="getJobSite()">
        <option value="unableToComplete">Unable to complete</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="all">All</option>
      </select>
    </div>

    <h2 v-if="sites.length === 0">No {{ option }} found</h2>

    <div v-for="(site, index) in paginated" :key="index">
      <div class="feature admin-dashboard-container" style="background-color: var(--secondary-color);">
        <div class="feature admin-dashboard-container">
          <button class="primary-button small-button" @click="setAsPending(site.jobSiteId)">
            🕓 Set as Pending
          </button>
        </div>

        <div class="feature admin-dashboard-container">
          <b>Website where it was posted</b>
          <input
            class="input-container input-container-medium"
            style="margin-top: 0.5rem;"
            :ref="`input-${index}-unableToComplete`"
            type="text"
            :value="site.postLink"
          />
          <button
            class="primary-button small-button"
            style="margin-top: 0.5rem;"
            @click="setAsComplete(site.jobSiteId, $refs[`input-${index}-unableToComplete`].value)"
          >
            ✅ Set as Complete
          </button>
        </div>

        <div class="feature admin-dashboard-container">
          <b> Reason this post is unable to complete</b>
          <input
            class="input-container input-container-medium"
            style="margin-top: 0.5rem;"
            :ref="`input-${index}-complete`"
            type="text"
            :value="site.postLink"
          />
          <button
            class="primary-button small-button"
            style="margin-top: 0.5rem;"
            @click="setAsUnableToComplete(site.jobSiteId, $refs[`input-${index}-complete`].value)"
          >
            ⚠️ Set as Unabled to Complete
          </button>
        </div>
      </div>

      <div class="feature admin-dashboard-container">
        <b>JobSite ID</b>
        <div>{{ site.jobSiteId }}</div>
      </div>
      <div class="feature admin-dashboard-container"><b>Site ID</b> {{ site.siteId }}</div>
      <div class="feature admin-dashboard-container"><b>Name</b>{{ site.name }}</div>
      <div class="feature admin-dashboard-container">
        <b>Completed link</b>
        <a :href="site.url">{{ site.url }}</a>
      </div>
      <div class="feature admin-dashboard-container"><b>Niche</b>{{ site.niche }}</div>
      <div class="feature admin-dashboard-container"><b>State</b>{{ site.state }}</div>
      <div class="feature admin-dashboard-container">
        <b>Completed link</b>
        <a :href="site.completedLink">{{ site.completedLink }}</a>
      </div>
      <div class="feature admin-dashboard-container"><b>Country</b>{{ site.country }}</div>
      <div class="feature admin-dashboard-container"><b>Reason unable to complete</b>{{ site.reasonUnableToComplete }}</div>
      <div class="feature admin-dashboard-container"><b>Created at</b>{{ site.createdAt.toDate().toDateString() }}</div>

      <div v-if="site.state === 'completed'">
        <div>completedLink: {{ site.completedLink }}</div>
        <div>
          postLink: <a :href="site.postLink">{{ site.postLink }}</a>
        </div>
      </div>
    </div>

    <div class="pagination-container">
      <button v-if="currentPage !== 0" @click="previous()" class="secondary-button small-button pagination-button">
        <i class="fas fa-arrow-left previous-page-button-icon"></i> Previous
      </button>
      <button v-if="m()" @click="next()" class="secondary-button small-button">
        Next <i class="fas fa-arrow-right next-page-button-icon"></i>
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import utils from "@/utils";
import Toast from "@/components/Toast";
export default {
  components: {
    Toast,
  },
  created() {
    window.scrollTo(0, 0);
  },
  data() {
    return {
      sites: [],
      option: "pending",
      currentPage: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    paginated() {
      return this.sites.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    },
  },
  mounted() {
    this.getJobSite();
  },
  methods: {
    m() {
      const maxPages = Math.trunc(this.sites.length / this.itemsPerPage);
      return this.currentPage + 1 < maxPages;
    },
    next() {
      this.currentPage++;
      window.scrollTo(0, 0);
    },
    previous() {
      this.currentPage--;
      window.scrollTo(0, 0);
    },

    async setAsPending(id) {
      const r = await firebase.functions.httpsCallable("setJobPostToPending")({
        jobSiteId: id,
      });
      if (r.data.errors.length !== 0) {
        alert(r.data.errors);
        return;
      }

      this.getJobSite();
    },

    async setAsUnableToComplete(id, reason) {
      if (reason == null || reason === "") {
        this.$refs.toast.text = `It needs a valid reason to be mark as Unable to complete`;
        await this.$refs.toast.show();
        return;
      }

      const r = await firebase.functions.httpsCallable("setJobPostToUnableToComplete")({
        jobSiteId: id,
        reasonUnableToComplete: reason,
      });
      if (r.data.errors.length !== 0) {
        alert(r.data.errors);
        return;
      }

      this.getJobSite();
    },

    async setAsComplete(id, postLink) {
      if (!utils.validURL(postLink)) {
        this.$refs.toast.text = `Invalid url: "${postLink}"`;
        await this.$refs.toast.show();
        return;
      }

      const r = await firebase.functions.httpsCallable("setJobPostToCompleted")({
        jobSiteId: id,
        link: postLink,
      });
      if (r.data.errors.length !== 0) {
        alert(r.data.errors);
        return;
      }

      this.getJobSite();
    },

    getJobSite() {
      let promise = firebase.firestore.collection("job-site").where("jobId", "==", this.$route.params.id);

      if (this.option !== "all") {
        promise = promise.where("state", "==", this.option);
      }

      promise
        .get()
        .then(async (s) => {
          this.sites = [];
          for (const doc of s.docs) {
            const siteSnap = await this.getSite(doc.data().siteId);
            const site = Object.assign({}, siteSnap.data(), doc.data());
            site.jobSiteId = doc.id;
            site.siteId = siteSnap.id;
            this.sites.push(site);
          }
        })
        .catch((e) => console.error(e));
    },
    async getSite(id) {
      try {
        return await firebase.firestore
          .collection("sites")
          .doc(id)
          .get();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped></style>
